export const WORKTYPES = {
    MH_WORK: 54,
    MISCELLANEOUS: 114,
    BURIED_WORK: 115,
    AERIAL_WORK: 116,
    COPPER_DECOM: 117,
};
